import { OperationLayerSet } from '@festina-life/api'
import { useMemo } from 'react'

import { useOperationsContext } from '../../../workspace/operationsContext'

export const useConfiguredLayers = () => {
  const {
    templateOperations,
    parameterDefinitionCreateOperations,
    parameterValueEntityOperations,
    configuredEnums,
    registeredTenantCreateOperations,
  } = useOperationsContext()

  return useMemo(
    () =>
      Array.from(
        new OperationLayerSet([
          // Array.from() is required because Map.values()/keys() return iterators.
          // ES2025 Iterator Helpers (.flatMap on iterators) are not available in Node 20,
          // which is used by the Vitest test environment.
          ...Array.from(templateOperations.values()).flatMap((values) =>
            Array.from(values.keys()),
          ),
          ...Array.from(parameterDefinitionCreateOperations.values()).flatMap(
            (values) => Array.from(values.keys()),
          ),
          ...Array.from(parameterValueEntityOperations.values()).flatMap(
            (values) => Array.from(values.keys()),
          ),
          ...Array.from(configuredEnums.values()).flatMap((values) =>
            Array.from(values.keys()),
          ),
          ...Array.from(registeredTenantCreateOperations.values()).flatMap(
            (values) => Array.from(values.keys()),
          ),
        ]).values(),
      ).sort((a, b) => {
        if (a.tenantId && b.tenantId) {
          return a.tenantId.localeCompare(b.tenantId)
        }
        if (a.tenantId) {
          return -1
        }
        if (b.tenantId) {
          return 1
        }
        return (a.layerId ?? '').localeCompare(b.layerId ?? '')
      }),
    [
      templateOperations,
      parameterDefinitionCreateOperations,
      parameterValueEntityOperations,
      configuredEnums,
      registeredTenantCreateOperations,
    ],
  )
}
